import { colors } from '@globals/themes/defaultTheme'
import { spacing } from '@globals/themes/themeConstants'
import { TenantMemberDisplayData } from '@kudos/http-client'
import AvatarGroup from '@mui/material/AvatarGroup'
import Badge, { BadgeProps } from '@mui/material/Badge'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { SxProps, styled } from '@mui/material/styles'
import UserAvatar from '@shared/avatar/UserAvatar'
import { ReactNode } from 'react'

const avatarGroupStyle: SxProps = {
  '& .MuiAvatarGroup-avatar': {
    marginLeft: spacing(-1),
  },
}

export const StyledBadge = styled(Badge)<BadgeProps>({
  '& .MuiBadge-badge': {
    backgroundColor: colors.grayExtraLight,
    top: -4,
    right: -4,
    padding: 4,
    height: 28,
    width: 28,
    borderRadius: 100,
  },
})

export const badgeContentStyle: SxProps = {
  mt: { xs: 0, sm: 0 },
  color: colors.grayPrimary,
  fontSize: 16,
}

type StandardCardGroupDisplayProps = {
  maxAvatars: number
  componentKey: string
  total: number
  tenantMemberDisplayData?: TenantMemberDisplayData[]
  text: ReactNode
}

const StandardCardGroupDisplay: React.FC<StandardCardGroupDisplayProps> = ({
  maxAvatars,
  componentKey,
  total,
  tenantMemberDisplayData = [],
  text,
}) => {
  const visibleAvatars = tenantMemberDisplayData.slice(0, maxAvatars)

  const avatar = (item: TenantMemberDisplayData, key: string) => (
    <Stack
      key={key}
      direction="column"
      useFlexGap
      spacing={2}
      sx={{
        alignItems: 'center',
      }}>
      <UserAvatar
        tenantMemberId={item?.id}
        firstName={item.firstName}
        lastName={item.lastName}
        media={item.avatarUrls}
      />
    </Stack>
  )

  return (
    <Stack
      spacing={0.5}
      sx={{
        alignItems: 'flex-start',
      }}>
      <AvatarGroup max={maxAvatars} sx={avatarGroupStyle}>
        {visibleAvatars.map((item, index) => {
          const key = `avatar-${componentKey}-${item.id}`
          if (index === maxAvatars - 1 && total > maxAvatars) {
            return (
              <StyledBadge
                key={key}
                badgeContent={
                  <Typography variant="button" sx={badgeContentStyle}>{`+${
                    total - maxAvatars
                  }`}</Typography>
                }
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}>
                {avatar(item, key)}
              </StyledBadge>
            )
          }
          return avatar(item, key)
        })}
      </AvatarGroup>
      <Typography variant="caption">{text}</Typography>
    </Stack>
  )
}

export default StandardCardGroupDisplay
